import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <div className="hero-container">
            <div className="hero-content">
                <h1>Urban Bites</h1>
                <h3>New York Style Pizza with San Francisco Spirit</h3>
                <p>
                    For 30 years, Urban Bites has delivered exceptional Italian cuisine in San Francisco.
                    Our menu offers mouthwatering pizza, calzones, pasta, sandwiches, salads, and vegan options.
                </p>
                <div className="hero-buttons">
                    <a href="/menu" className="btn-primary">View Menu</a>
                </div>
            </div>
        </div>
    );
};

export default Hero;
